import { TransformInt } from '../../../decorators/transform-int.decorator';
import { AppSubjectEnum } from '../../authz/enums/app-subject.enum';

/**
 * Delete status tracking DTO
 */
export class DeleteStatusTrackingDto {
	sourceSubject!: AppSubjectEnum;
	@TransformInt()
	sourceId!: number;
	targetSubject?: AppSubjectEnum;
	@TransformInt()
	targetId?: number;
	group?: string;
}
